// Module
var code = "AI Spieler <strong><span data-ref=\"display-name\"></span></strong> setzt auf <strong><span data-ref=\"team\"></span></strong><span data-ref=\"result\"> und liegt damit <strong><span data-ref=\"outcome\"></span></strong></span>. <h4>Begründung</h4> <p data-ref=\"reason\"></p>";
// Exports
export default code;